import React from 'react'

function Youtubevideo() {
  return (
    <div>

      <div className="album py-2">
        <div className="container">
          <div className="row ">
            <div className="col-md-4">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/rRO8ibhJgyA"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="col-md-4">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/ztleRKKCNs8"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="col-md-4">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/dm2L1ALH_sk"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Youtubevideo